import React from "react";
import KeyManagementTabs from "./KeyManagement/KeyManagementTabs";

function KeyManagementDashboard(props) {
  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <KeyManagementTabs terminalsData={props.terminalsData}/>
          </div>
        </div>
      </div>
    </div>
  );
}

export default KeyManagementDashboard;

